import React, { useState, useEffect } from 'react';
import { MapPin, Phone, Mail, Clock, Eye } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [visitorCount, setVisitorCount] = useState(0);

  useEffect(() => {
    const trackVisitor = async () => {
      try {
        const res = await axios.post(`${BACKEND_URL}/api/visitors/track`);
        setVisitorCount(res.data.count);
      } catch { /* silently fail */ }
    };
    trackVisitor();
  }, []);

  return (
    <footer id="contact" className="relative flex items-center justify-center bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 text-white overflow-hidden">
      {/* Watermark */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-5">
        <h1 className="text-[5rem] md:text-[12rem] font-bold text-white select-none">
          PRIMESWIFT
        </h1>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <img
              src="https://customer-assets.emergentagent.com/job_freight-flow-51/artifacts/jlvfmutc_logo%20files.png"
              alt="Primeswift Solutions"
              className="h-12 w-auto mb-4"
            />
            <p className="text-gray-300 mb-4 leading-relaxed">
              Your trusted logistics partner delivering excellence across India with innovative solutions and reliable service.
            </p>
            <p className="text-gray-400 text-sm">Connect with us on social media - Coming soon!</p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {[
                { label: 'Services', href: '#services' },
                { label: 'Why Choose Us', href: '#why-choose-us' },
                { label: 'Join Our Fleet', href: '#join-fleet' },
                { label: 'Get Quote', href: '#get-quote' },
                { label: 'About Us', href: '#about-us' },
                { label: 'Career', href: '/driver-jobs', isRoute: true },
                { label: 'Blog', href: '/blog', isRoute: true },
              ].map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-gray-300 hover:text-blue-400 transition-colors" data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-4">Our Services</h3>
            <ul className="space-y-2 text-gray-300">
              <li>Freight & Transportation</li>
              <li>Warehousing Solutions</li>
              <li>Last-Mile Delivery</li>
              <li>Supply Chain Management</li>
              <li>Express Shipping</li>
              <li>Cargo Insurance</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-blue-400 flex-shrink-0 mt-1" />
                <span className="text-gray-300">
                  C-425, Gera's Imperium Gateway,<br />
                  Bhosari Metro Station,<br />
                  Pune - 411034
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-blue-400" />
                <span className="text-gray-300">+91-9579027425</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-blue-400" />
                <span className="text-gray-300">info@primeswift.in</span>
              </li>
              <li className="flex items-center space-x-3">
                <Clock className="h-5 w-5 text-blue-400" />
                <span className="text-gray-300">24/7 Support Available</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} Primeswift Solutions Pvt Ltd. All rights reserved.
            </p>
            <div className="flex items-center space-x-2 text-gray-400 text-sm" data-testid="visitor-counter">
              <Eye className="w-4 h-4" />
              <span>{visitorCount > 0 ? visitorCount.toLocaleString() : '—'} Visitors</span>
            </div>
            <div className="flex space-x-6 text-sm text-gray-400">
              <a href="/privacy-policy" className="hover:text-blue-400 transition-colors">Privacy Policy</a>
              <a href="/terms-of-service" className="hover:text-blue-400 transition-colors">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
